// frontend/src/constants/routes.js
/**
 * Application route paths.
 */

export const ROUTES = {
  // Public routes
  HOME: '/',
  LOGIN: '/login',
  MAINTENANCE: '/maintenance',

  // Main application routes
  DASHBOARD: '/dashboard',
  CALENDAR: '/calendar',
  RECURRING_EVENTS: '/recurring-events',
  CLIENTS: '/clients',
  CLIENT_DETAIL: '/clients/:id',
  PROFILE: '/profile',
  WORK_HOURS: '/work-hours',
  TIME_OFF: '/time-off',
  INVOICES: '/invoices',
  EMAILS: '/emails',

  // Detail pages
  REPORT_DETAIL: '/reports/:id',
  EMPLOYEE_DETAIL: '/employee/:id',

  // Admin routes
  ADMIN_PANEL: '/admin',
  SETTINGS: '/settings'
};

/**
 * Build route path with parameters.
 *
 * @param {string} route - Route template (e.g., '/clients/:id')
 * @param {Object} params - Parameters to inject (e.g., {id: 123})
 * @returns {string} - Complete route path
 */
export const buildRoute = (route, params = {}) => {
  let path = route;

  Object.entries(params).forEach(([key, value]) => {
    path = path.replace(`:${key}`, value);
  });

  return path;
};

/**
 * Check if current path matches route.
 *
 * @param {string} currentPath - Current location pathname
 * @param {string} route - Route to check against
 * @returns {boolean} - True if matches
 */
export const matchesRoute = (currentPath, route) => {
  // Convert route pattern to regex
  const pattern = route.replace(/:[^/]+/g, '[^/]+');
  const regex = new RegExp(`^${pattern}$`);
  return regex.test(currentPath);
};

/**
 * Get route name from path.
 *
 * @param {string} path - Current path
 * @returns {string|null} - Route name or null
 */
export const getRouteName = (path) => {
  for (const [name, route] of Object.entries(ROUTES)) {
    if (matchesRoute(path, route)) {
      return name;
    }
  }
  return null;
};

// Route labels in German
export const ROUTE_LABELS = {
  [ROUTES.HOME]: 'Start',
  [ROUTES.DASHBOARD]: 'Dashboard',
  [ROUTES.CALENDAR]: 'Kalender',
  [ROUTES.RECURRING_EVENTS]: 'Wiederkehrende Termine',
  [ROUTES.CLIENTS]: 'Klienten',
  [ROUTES.PROFILE]: 'Profil',
  [ROUTES.WORK_HOURS]: 'Arbeitsstunden',
  [ROUTES.TIME_OFF]: 'Urlaub',
  [ROUTES.INVOICES]: 'Rechnungen',
  [ROUTES.EMAILS]: 'E-Mails',
  [ROUTES.ADMIN_PANEL]: 'Admin',
  [ROUTES.SETTINGS]: 'Einstellungen'
};

export default {
  ROUTES,
  buildRoute,
  matchesRoute,
  getRouteName,
  ROUTE_LABELS
};
